import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { Balance, InvoiceApiData, InvoiceData } from '../../models/Invoice';

const URL = '/api/v1/invoices';
const BALANCE_URL = '/api/v1/invoices/balance';

const useInvoices = () => {
    const useInvoicesSWR = () => {
        const createData = (data: InvoiceApiData): InvoiceData => {
            return {
                id: data.id,
                invoiceNumber: data.number,
                date: data.invoiceDate,
                paid: data.postingDate,
                paymentDeadline: data.dueDate,
                price_net: data.totalAmountExcludingTax,
                price_gross: data.totalAmountIncludingTax,
                status: data.status,
                downloadLink: '',
                orderId: data.orderId,
                shopifyOrderId: data.shopifyOrderID,
                // shopifyOrderName: data.orderId,
            };
        };
        const fetch = (query): Promise<InvoiceApiData> => {
            return httpApi
                .get<{ invoices: InvoiceApiData }>(query)
                .then((res) => {
                    return res.getData().invoices;
                })
                .catch((error) => {
                    throw error;
                });
        };

        const { data, error, isLoading, mutate } = useSWR(URL, fetch, {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        });

        const convertData = (data): InvoiceData[] => {
            return data.map((elem) => {
                return createData(elem);
            });
        };

        return {
            invoices: data ? convertData(data) : null,
            isLoading: isLoading,
            isError: error,
            forceRefresh: mutate,
        };
    };

    const useInvoicesBalanceSWR = () => {
        const fetch = (query): Promise<Balance> => {
            return httpApi
                .get<{ balance: Balance }>(query)
                .then((res) => {
                    return res.getData().balance;
                })
                .catch((error) => {
                    throw error;
                });
        };

        const { data, error, isLoading, mutate } = useSWR(BALANCE_URL, fetch, {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        });

        return {
            balances: data,
            isLoading: isLoading,
            isError: error,
            forceRefresh: mutate,
        };
    };

    return {
        useInvoicesSWR,
        useInvoicesBalanceSWR,
    };
};

export default useInvoices;
